import { deleteMyUserAccount } from '@echo/api-client/onearly';
import { useMutation } from '@tanstack/react-query';
import { useSessionManager } from './provider';

/**
 * Account › Delete account: Core removes the OnEarly identity and the user, then the session
 * ends here. A failed delete leaves the person signed in.
 */
export function useDeleteAccount() {
  const sessionManager = useSessionManager();
  return useMutation({
    mutationFn: async () => {
      const response = await deleteMyUserAccount();
      if (response.status !== 200) throw new Error(`OnEarly: unexpected status ${response.status}`);
    },
    onSuccess: () => sessionManager.signOut(),
  });
}
